import {Card, Row, Col, Collapse} from 'antd'
import {useEffect, useState} from 'react'
import {Params, useFetchGet} from 'helpers/api'
import {DELTA_THERMAL_GLOBAL_HQ, MINZOOM, toLocations} from 'helpers/locations'
import {getAlphaLabel} from 'helpers/labels'
import PathMap from '../../../../components/path-map'
import RailGWStatusSummary from '../../../../components/railgwstatus-summary'
const {Panel} = Collapse

const RailgwMapRow = ({gatewayId, handleGatewayClick}) => {
  const [data, setData] = useState()
  const [limit, setLimit] = useState(20)
  const fetchRailgwlocationsview = useFetchGet('railgwlocationsview')
  const [locations, setLocations] = useState()
  const [minZoom, setMinZoom] = useState(MINZOOM.GATEWAYS)
  const [activeKey, setActiveKey] = useState(1) // Controls which panel is open

  const handleChange = key => {
    // Toggle the panel: if the same key is clicked again, close it
    setActiveKey(activeKey === key ? null : key)
  }

  const getRailgwstatusview = () => {
    const params = Params({g_id: gatewayId, limit})
    fetchRailgwlocationsview(params, response => {
      setData(response.railgwlocationsview)
      toRailgwlocations(response.railgwlocationsview)
      toRailgwsummary(response.railgwlocationsview)
    })
  }

  useEffect(() => {
    if (gatewayId) getRailgwstatusview()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gatewayId, limit])

  const toRailgwlocations = railgwlocationsview => {
    if (railgwlocationsview && railgwlocationsview.length > 0) {
      let mapIndex = 0
      const items = railgwlocationsview.reduce((acc, row) => {
        if (row.latitude && row.longitude) {
          const mapKey = getAlphaLabel(mapIndex)
          row.mapKey = mapKey
          const item = {
            key: mapKey,
            id: row.id,
            name: row.g_name,
            latitude: row.latitude,
            longitude: row.longitude,
            timestamp: row.timestamp,
            info: {
              'Position Accuracy': row.position_accuracy,
              Speed: row.speed,
              'Speed Accuracy': row.speed_accuracy,
              Heading: row.heading,
              'Heading Accuracy': row.heading_accuracy,
              Voltage: row.voltage,
              Current: row.current
            }
          }
          acc.push(item)
          mapIndex++
        }
        return acc
      }, [])

      setLocations(toLocations(items.reverse()))
    } else {
      // Show DT Headquarters location; leave off id to make not clickable
      setLocations(toLocations([DELTA_THERMAL_GLOBAL_HQ]))
      setMinZoom(MINZOOM.SITES)
    }
  }

  const fields = ['position_accuracy', 'speed', 'speed_accuracy', 'heading', 'heading_accuracy', 'voltage', 'current']
  const values = () => {
    return Object.fromEntries(fields.map(field => [field, 0]))
  }

  function toRailgwsummary(railgwlocationsview) {
    if (!Array.isArray(railgwlocationsview) || railgwlocationsview.length === 0) {
      console.warn('Invalid or empty railgwlocationsview:', railgwlocationsview)
      setData({
        begin: null,
        end: null,
        current: values(),
        average: values(),
        count: 0
      })
      return
    }

    console.log('Analyzing', railgwlocationsview.length, 'records...')

    const mostRecent = railgwlocationsview[0]
    const earliest = railgwlocationsview[railgwlocationsview.length - 1]

    const lastTimestamp = mostRecent.timestamp
    const firstTimestamp = earliest.timestamp

    const totals = values()

    let count = 0

    for (const item of railgwlocationsview) {
      fields.forEach(field => {
        const value = parseFloat(item[field])
        if (!isNaN(value)) {
          totals[field] += value
        } else {
          totals[field] += 0
          console.warn(`Invalid value for field "${field}":`, item[field])
        }
      })
      count++
    }

    const averages = {}
    const currentValues = {}

    fields.forEach(field => {
      averages[field] = +(totals[field] / count).toFixed(2)
      currentValues[field] = +parseFloat(mostRecent[field]).toFixed(2)
    })

    setData({
      begin: firstTimestamp,
      end: lastTimestamp,
      current: currentValues,
      average: averages,
      count: count
    })
  }

  return (
    <Collapse activeKey={activeKey} onChange={handleChange}>
      <Panel header="Location" key="1" className="custom-panel">
        <Row gutter={16} style={{margin: '15px'}}>
          {/* Sites Card - takes 1/4 width */}
          <Col xs={24} md={8}>
            <Card className="max-w-full">
              <div style={{height: '50vh'}}>
                <RailGWStatusSummary data={data} limit={limit} setLimit={setLimit} />
              </div>
            </Card>
          </Col>

          {/* Locations Map Card - takes 3/4 width */}
          <Col xs={24} md={16}>
            <Card className="max-w-full">
              <div style={{height: '50vh', width: '61vw'}}>
                <PathMap
                  locations={locations}
                  onLocationClick={location => handleGatewayClick(location)}
                  minZoom={minZoom}
                />
              </div>
            </Card>
          </Col>
        </Row>
      </Panel>
    </Collapse>
  )
}

export default RailgwMapRow
